import { Link } from 'react-router-dom';

import { DEFAULT_ROUTE } from '../app/module-registry';
import { Button, EmptyState } from '../ui/primitives';

export function NotFound(): JSX.Element {
  return (
    <EmptyState
      title="Page not found"
      description="That URL doesn't match anything in the CRM. It may have been moved, or the link may be out of date."
      action={
        <Link to={DEFAULT_ROUTE}>
          <Button variant="outline">Back to dashboard</Button>
        </Link>
      }
    />
  );
}
